import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_Action, DBDef_OrderGroup } from '@app/pathway-shared';
import { Button, ComponentSync, LL_V_L, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import { exists, filterDuplicates, filterInstances, sortArray } from '@nu-art/ts-common';
import { ModuleFE_Action, ModuleFE_OrderGroup, ModuleFE_PathwayTransition } from '../../../../../../_entity.js';
import { UtilObject_Action } from '../../../../../../search/items/action.js';
import { UtilObject_OrderGroup } from '../../../../../../search/items/order-group.js';
import './Renderer_PathwayActions.scss';
export class Renderer_PathwayActions extends ComponentSync {
    deriveStateFromProps(nextProps, state) {
        state.pathwayId = nextProps.pathwayId;
        state.transitionId = nextProps.transitionId;
        const transitions = this.getTransitions(state.pathwayId, state.transitionId);
        const pointers = filterDuplicates(this.getPointers(transitions), pointer => pointer.id);
        state.orders = sortArray(filterInstances(pointers
            .filter(pointer => pointer.dbKey === DBDef_Action.dbKey)
            .map(pointer => ModuleFE_Action.cache.unique(pointer.id))), order => order.label);
        state.orderGroups = sortArray(filterInstances(pointers
            .filter(pointer => pointer.dbKey === DBDef_OrderGroup.dbKey)
            .map(pointer => ModuleFE_OrderGroup.cache.unique(pointer.id))), group => group.label);
        return state;
    }
    getTransitions(pathwayId, transitionId) {
        if (exists(transitionId))
            return [ModuleFE_PathwayTransition.cache.unique(transitionId)];
        return ModuleFE_PathwayTransition.cache.filter(t => t.pathwayIds.includes(pathwayId));
    }
    getPointers(transitions) {
        return transitions.map(transition => {
            return [
                ...transition.testsIds ?? [],
                ...transition.nurseIds ?? [],
                ...transition.consultIds ?? [],
                ...transition.treatmentsIds ?? [],
            ];
        }).flat();
    }
    render() {
        return _jsx(TS_CollapsableContainerV2, { className: 'pathway-actions', headerRenderer: this.render_Header, containerRenderer: this.render_Actions, forceUpdate: true, animated: true });
    }
    render_Header = () => {
        // Ticket #10157 point 6.c — per-transition matches old `Renderer_TransitionOrders` header (just "Orders").
        // Pathway-level keeps the aggregate count, which is informative across the whole pathway.
        if (exists(this.state.transitionId))
            return 'Orders';
        return `${this.state.orderGroups.length + this.state.orders.length} Orders and groups`;
    };
    render_Actions = () => {
        return _jsxs(LL_V_L, { children: [this.state.orderGroups.map(group => {
                    return _jsxs(Button, { variant: 'text', onClick: () => UtilObject_OrderGroup.openEditor(group._id), children: ["[Group] ", group.label ?? group.name] }, group._id);
                }), this.state.orders.map(order => {
                    return _jsxs(Button, { variant: 'text', onClick: () => UtilObject_Action.openEditor(order._id), children: ["[Order] ", order.label ?? order.name] }, order._id);
                })] });
    };
}
//# sourceMappingURL=Renderer_PathwayActions.js.map